import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CACHE_KEY = "primes4.brand.logo.v1";

// Reads the cached platform/partner logo synchronously so we render with the
// last-known logo on first paint (no flash of fallback text). The Header,
// Admin, Consultant, and Client layouts all share the same cache key.
function readCache() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed.logo === "string") return parsed.logo;
  } catch { /* ignore */ }
  return null;
}

function writeCache(logo) {
  try { localStorage.setItem(CACHE_KEY, JSON.stringify({ logo, fetched_at: Date.now() })); }
  catch { /* quota exceeded — non-critical */ }
}

/**
 * usePlatformLogo
 * Returns the data-URL for the active brand logo (partner_logo wins over
 * platform_logo so white-label installs override the default PrimeS4 mark).
 * Falls back to an empty string when no logo has been uploaded.
 */
export default function usePlatformLogo() {
  const [logo, setLogo] = useState(() => readCache() || "");

  useEffect(() => {
    let cancelled = false;
    axios.get(`${API}/branding/public`).then((r) => {
      if (cancelled) return;
      const b = r.data || {};
      const next = b.partner_logo || b.platform_logo || "";
      setLogo(next);
      writeCache(next);
    }).catch(() => { /* keep cached value on transient errors */ });
    return () => { cancelled = true; };
  }, []);

  return logo;
}
